import { UserOrderGetters, AgnosticPrice } from '@vue-storefront/core';
import type { Order, OrderItem, PreOrder } from '@bee-hole/api';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getDate(order: Order): string {
  return order?.createTime;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getId(order: Order): string {
  return order.orderId;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getStatus(order: Order): string {
  return order?.status;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getPrice(order: Order): number | null {
  return order?.payment;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getItems(order: Order): OrderItem[] {
  return order?.orderItem || [];
}
function getOrder(order: Order[]): Order[] {
  return order;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getItemSku(item: OrderItem): string {
  return String(item?.skuId);
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getItemName(item: OrderItem): string {
  return item?.title;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getGoodId(item: OrderItem): string {
  return String(item?.goodId || '');
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getItemQty(item: OrderItem): number {
  return item?.num;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getItemPrice(item: OrderItem): number {
  return Number(item?.price);
}
function getItemAgnosticPrice(item: OrderItem): AgnosticPrice {
  // return item?.price;
  if (item?.discount) {
    if (item.isGift) {
      return {
        regular: item.totalPayment,
        special: 0
      };
    } else {
      return {
        regular: (item.price * item.num) + (item.taxFee * item.num),
        special: item.totalPayment
      };
    }

  } else {
    return {
      regular: item.totalPayment,
      special: 0
    };
  }
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getFormattedPrice(price: number): string {
  return '';
}

// eslint-disable-next-line
function getOrdersTotal(orders: any): number {
  return orders ? orders.length : 0;
}

function getOrderSummaryOrder(order: Order): any {
  const items = [];
  if (order.orderItem) {
    order.orderItem.map(item => {
      items.push({
        title: item.title,
        price: { regular: '$' + item.price, special: '$' + item.price },
        qty: item.num,
        sku: item.skuProp
      });
    });
  }
  const data = {
    shipping: { shippingMethod: { isOpen: true, price: String(order?.postFee), delivery: 'Delivery from 3 to 7 business days', label: 'Pickup in the store', value: 'store', description: 'Novelty! From now on you have the option of picking up an order in the selected InPack parceled. Just remember that in the case of orders paid on delivery, only the card payment will be accepted.' } },
    orderItems: items
  };
  return data;
}
// 订单预览右侧订单组件的数据结构
function getOrderListSummaryOrder(preOrder: PreOrder): any {
  // console.log('$-------------', $n(11, 'currency'))
  const items = [];
  let postFee = 0;
  let postTaxFee = 0;
  let insuranceFee = 0;
  let insuranceTaxFee = 0;
  let discount = 0;
  let subtotal = 0;
  let shippingDetail = {
    state: null,
    city: null,
    street: null,
    apartment: null,
    zipCode: null,
    phone: null,
    lastName: null,
    firstName: null,
    country: null
  };
  if (preOrder?.orders && preOrder?.orders?.length) {
    preOrder?.orders.map(order => {
      if (order.postFee) {
        postFee += order.postFee;
        postTaxFee += order.postFeeTax;
      }
      if (order.discount) {
        discount = Number((Number(discount) + Number((order.discount || 0))).toFixed(2));
      }
      if (order.insuranceFee) {
        insuranceFee += order.insuranceFee;
        insuranceTaxFee += order.insuranceTax;
      }
      if (order.orderItem) {
        order.orderItem.map(item => {
          // if (order.discount && !item.discount) {
          //   discount += order.discount;
          // }
          if (item.totalPayment) {
            subtotal += item.totalPayment;
          } else {
            subtotal = item.price * item.num;
          }
          items.push({
            title: item.title,
            price: { regular: String(item.price * item.num), special: String(item.totalPayment) },
            qty: 1,
            sku: item.skuProp,
            taxfee: item.taxFee
          });
        });
      }
      if (!shippingDetail || shippingDetail.state === null) {
        shippingDetail = {
          state: order.state,
          city: order.city,
          street: order.street,
          apartment: order.apartment,
          zipCode: order.zipCode,
          phone: order.phone,
          lastName: order.lastName,
          firstName: order.firstName,
          country: order.country
        };
      }
    });
  }
  const data = {
    shipping: { shippingMethod: { isOpen: false, price: String(postFee), postTaxFee: String(postTaxFee), insuranceFee: String(insuranceFee), insuranceTaxFee: String(insuranceTaxFee), delivery: 'Delivery from 3 to 7 business days', label: 'Pickup in the store', value: 'store', description: 'Novelty! From now on you have the option of picking up an order in the selected InPack parceled. Just remember that in the case of orders paid on delivery, only the card payment will be accepted.' } },
    orderItems: items,
    discount: discount,
    shippingDetail: shippingDetail,
    subtotal
  };
  return data;
}

function getShouHouSkuInfo(items: OrderItem[]): any {
  const arr = [];
  if (items) {
    items.forEach((item) => {
      arr.push({
        sku_id: item.skuId,
        num: item.num
      });
    });
  }
  return arr;
}
function getItemImg(items: OrderItem): string {
  return items?.imgUrl;
}
function getItemAttributes(items: OrderItem): any {
  // const arr = items?.skuProp?.split(';')
  if (typeof items?.skuProp === 'string') {
    if (items?.skuProp.indexOf('{') !== -1) {
      return JSON.parse(items?.skuProp);
    } else {
      return items?.skuProp.split(';');
    }
  } else {
    return items?.skuProp;
  }
}
export const orderGetters: UserOrderGetters<Order, OrderItem> = {
  getDate,
  getId,
  getStatus,
  getPrice,
  getItems,
  getItemSku,
  getItemName,
  getItemQty,
  getItemPrice,
  getItemAgnosticPrice,
  getFormattedPrice,
  getOrdersTotal,
  getOrderSummaryOrder,
  getOrderListSummaryOrder,
  getGoodId,
  getShouHouSkuInfo,
  getOrder,
  getItemImg,
  getItemAttributes
};
